import { LoaderFunction } from "react-router-dom";

import { backendApi } from "../../api";
import { queryOptions } from "@tanstack/react-query";
import { queryClient } from "../../queryClient";
interface Medication {
  induction_dose: string;
  maintenance_dose: string;
  route: string;
}
export interface formatThreeQuestions {
  questions: { [key: string]: { [key: string]: number } };
  treatments: { [key: string]: string[] };
  medications: { [key: string]: Medication };
}

function crohnsQuery() {
  return queryOptions({
    queryKey: ["crohns"],
    queryFn: async ({ signal }) =>
      await backendApi<formatThreeQuestions>({
        url: "/algorithms/crohns-algorithm",
        signal,
      }),
    staleTime: 1000 * 60 * 60 * 24, // Expire after 24 hours
  });
}

export const loader: LoaderFunction = async () => {
  return (await queryClient.fetchQuery(crohnsQuery())).data;
};
